// extracted by mini-css-extract-plugin
export default {"WholeTeamMain":"WholeTeam_WholeTeamMain__+aCgl","cardist":"WholeTeam_cardist__OUcGD","cardbtn":"WholeTeam_cardbtn__l0XM0"};